<template>
    <div>

        <AuthorGalleryItemHorisontal v-if="authors.length === 1"
                                     :author="authors[0]"
                                     @authorClick="authorClick"/>

        <carousel v-else :responsive="{0:{items:1},1000:{items:descItemsCount}}" :margin="30">
            <AuthorGalleryItem v-for="item in authors"
                               :key="item.idauthor"
                               :center="true"
                               :author="item"
                               @authorClick="authorClick"/>
        </carousel>



        <div class="authors-popup-relative">
            <div class="authors-popup-absolute" :style="popupStyle">
                <AuthorPopup v-if="author"
                             :author="author"
                             @close="close"/>
            </div>
        </div>
    </div>
</template>

<script>
    import carousel from 'vue-owl-carousel'
    import AuthorGalleryItem from "./AuthorGalleryItem";
    import AuthorGalleryItemHorisontal from "./AuthorGalleryItemHorisontal";
    import AuthorPopup from "./AuthorPopup";

    export default {
        name: "AuthorsGallery",
        components: {
            AuthorPopup,
            AuthorGalleryItem,
            AuthorGalleryItemHorisontal,
            carousel
        },
        props: {
            authors: Array
        },

        data: function () {
            return {
                author: null,
                popupStyle: {top: 0, left: 0},
            }
        },

        computed: {
            descItemsCount() {
                return this.authors && this.authors.length < 3 ? this.authors.length : 3;
            },
        },

        methods: {
            authorClick(author, event) {
                this.$emit('click', author)
                this.popupStyle = {top: '-400px', left: (event.layerX - 100) + 'px'}
                this.author = author
            },

            close() {
                if (this.author != null) {
                    console.log('close AuthorsGallery')
                    this.author = null
                }
            }
        }

    }
</script>

<style>
    .authors-popup-relative {
        position: relative;
        max-width: 100%;
    }

    .authors-popup-absolute {
        position: absolute;
        max-width: 100%;
    }

    @media (max-width: 767px) {
        .authors-popup-absolute {
            left: 0 !important;
            top: -450px !important;
        }
    }

    .owl-stage {
        margin: 0 auto;
    }
</style>
